export const newEmployerCertificate = {
  // Page Title and Headers
  EMPLOYER_CERTIFICATE_PAGE_TITLE: "Arbetsgivarintyg",
  EMPLOYER_CERTIFICATE_HEADING: "Arbetsgivarintyg",
  EMPLOYER_CERTIFICATE_DESCRIPTION: "Generera och ladda ner ditt Arbetsgivarintyg",
  
  // Employer Certificate Header
  "Employer Certificate": "Arbetsgivarintyg",
  "employerCertificateTutorial":"Se hur vi kan beställa ett arbetsgivarintyg",
  "employerCertificateDescription": "När du har fått din första lön från oss kan du begära ett anställningsbevis. Ett anställningsbevis kan behövas när du ansöker om arbetslöshetsersättning. Det är viktigt att du fyller i dina timmar och lönen du får från oss, så verifiera detta med dina lönebesked från oss. Detta gör att ditt anställningsbevis kan granskas av oss och godkännas för vår signatur. När vi har godkänt och undertecknat det kommer du att få ett e-postmeddelande om att du kan logga in och hämta det från din portal.",
  
  // Work Hours Required
  "Work Hours Required": "Arbetstimmar krävs",
  "workHoursRequiredDescription": "För att generera ett Arbetsgivarintyg behöver du registrerade arbetstimmar i din tidrapport. Om du inte har loggat några timmar ännu, lägg till dem först.",
  "Create Timesheet": "Skapa tidrapport",
  
  // Certificates Table
  "Your certificates": "Dina intyg",
  "Search": "Sök",
  "Date from": "Datum från",
  "Date to": "Datum till",
  "Order Certificate": "Beställ intyg",
  "Duration": "Varaktighet",
  "Issued Date": "Utfärdandedatum",
  "Edit": "Redigera",
  "Download": "Ladda ner",
  "Delete": "Ta bort",
  "No data found": "Ingen data hittades",

  // Delete Confirmation Modal
  "Delete Certificate": "Ta bort certifikat",
  "Are you sure you want to delete this certificate?": "Är du säker på att du vill ta bort det här certifikatet?",
  "This action cannot be undone.": "Den här åtgärden kan inte ångras.",
  "Yes, Delete": "Ja, ta bort",
  "Cancel": "Avbryt",
  
  // Certificate Information
  CERTIFICATE_INFO: "Certifikatinformation",
  EMPLOYMENT_PERIOD: "Anställningsperiod",
  START_DATE: "Startdatum",
  END_DATE: "Slutdatum",
  CERTIFICATE_TYPE: "Certifikattyp",
  CERTIFICATE_DATE: "Certifikatdatum",
  
  // Actions
  GENERATE_CERTIFICATE: "Generera certifikat",
  DOWNLOAD_CERTIFICATE: "Ladda ner certifikat",
  PREVIEW_CERTIFICATE: "Förhandsgranska certifikat",
  REQUEST_CERTIFICATE: "Begär certifikat",
  
  // Certificate Details
  EMPLOYER_NAME: "Arbetsgivarens namn",
  EMPLOYEE_NAME: "Anställdas namn",
  POSITION: "Position",
  EMPLOYMENT_TYPE: "Anställningstyp",
  FULL_TIME: "Heltid",
  PART_TIME: "Deltid",
  
  // Status Messages
  CERTIFICATE_GENERATED_SUCCESS: "Certifikat genererat framgångsrikt",
  CERTIFICATE_DOWNLOAD_SUCCESS: "Certifikat nedladdat framgångsrikt",
  CERTIFICATE_REQUEST_SENT: "Certifikatbegäran skickad framgångsrikt",
  NO_CERTIFICATES_FOUND: "Inga certifikat hittades",
  LOADING_CERTIFICATES: "Laddar certifikat...",
  
  // Form Labels
  SELECT_PERIOD: "Välj period",
  CUSTOM_PERIOD: "Anpassad period",
  CURRENT_YEAR: "Innevarande år",
  LAST_YEAR: "Föregående år",
  ALL_TIME: "All tid",
  
  // Table Headers
  CERTIFICATE_LIST: "Certifikatlista",
  ISSUE_DATE: "Utfärdandedatum",
  PERIOD: "Period",
  STATUS: "Status",
  ACTIONS: "Åtgärder",
  
  // Certificate Status
  PENDING: "Väntande",
  APPROVED: "Godkänd",
  READY: "Klar",
  DOWNLOADED: "Nedladdad",
  
  // Validation Messages
  PLEASE_SELECT_START_DATE: "Vänligen välj ett startdatum",
  PLEASE_SELECT_END_DATE: "Vänligen välj ett slutdatum",
  END_DATE_MUST_BE_AFTER_START: "Slutdatum måste vara efter startdatum",
  "Start date is required": "Startdatum krävs",
  "End date is required": "Slutdatum krävs",
  "Year is required": "År krävs",
  "Amount is required": "Belopp krävs",
  
  // Additional Info
  CERTIFICATE_PURPOSE: "Syfte med certifikat",
  ADDITIONAL_NOTES: "Ytterligare anteckningar",
  OPTIONAL: "Valfritt",
  
  // New Order Form
  "Create New Order": "Skapa ny beställning",
  "Important": "Viktigt",
  "All information you enter in the Employer Certificate will appear in Swedish in the final certificate.": "All information du anger i arbetsgivarintyget kommer att visas på svenska i det slutliga certifikatet.",
  "Contract No.": "Kontraktsnr.",
  "Emp. name": "Anställds namn",
  "Social Security Number": "Personnummer",
  "12 digits": "12 siffror",
  "Employment Details": "Anställningsuppgifter",
  "Employment period": "Anställningsperiod",
  "Start date": "Startdatum",
  "End date": "Slutdatum",
  "Currently working": "Arbetar för närvarande",
  "Work Hours Recorded": "Registrerade arbetstimmar",
  "All registered working hours entered in the Timesheet section and/or referenced in invoices are displayed here.": "Alla registrerade arbetstimmar som anges i tidrapportavsnittet och/eller refereras i fakturor visas här.",
  "Month/Year": "Månad/År",
  "Avg. Work Duration": "Genomsnittlig arbetstid",
  "Absence": "Frånvaro",
  "Over Time": "Övertid",
  "Total Amount": "Totalt belopp",
  "Avg. Over Time": "Genomsnittlig övertid",
  "Leave Days": "Lediga dagar",
  "Avg. Break Duration": "Genomsnittlig rasttid",
  "Total Working Days": "Totalt antal arbetsdagar",
  
  // Discontinuation Details
  "Discontinuation Details": "Avslutningsdetaljer",
  "Reason why the employment has ended in whole or in part": "Anledning till att anställningen har avslutats helt eller delvis",
  "Reason type": "Anledningstyp",
  "Describe reason": "Beskriv anledning",
  "Type here...": "Skriv här...",
  "Select reason": "Välj anledning",
  "Other reason": "Annan anledning",
  "Contract ended": "Kontraktet upphörde",
  "Resignation": "Avgång",
  "Termination": "Uppsägning",
  "Resignation by employee": "Egen uppsägning",
  "Termination by employer": "Uppsägning av arbetsgivaren",
  "Mutual agreement": "Ömsesidig överenskommelse",
  "End of assignment": "Uppdragets slut",
  "Retirement": "Pensionering",
  "Redundancy / Laid off": "Arbetsbrist / varsel",
  "You are currently employed, so you cannot add a reason": "Du är för närvarande anställd, så du kan inte ange en anledning",
  
  // Salary Information
  "Information about the salary": "Information om lön",
  "Year": "År",
  "Select year": "Välj år",
  "Hourly salary": "Timlön",
  "Salary type": "Lönetyp",
  "Hourly": "Timlön",
  "salaryTypeTooltip": "Arbetsgivarintyg hos Invozio utfärdas uteslutande för timavlönade anställda. Ingen annan lönetyp kan väljas.",
  "Amount": "Belopp",
  "Enter amount": "Ange belopp",
  
  // Other Information
  "Other information": "Övrig information",
  "otherInfoDescription": "Individen har varit anställd av Invozio under den angivna perioden och har inte bedrivit verksamhet som egenföretagare inom ramen för uppdraget. Allt arbete har utförts som en anställd av Invozio, som har agerat som formell arbetsgivare och har varit ansvarig för lönebetalningar, skatteavdrag, arbetsgivaravgifter och rapportering till Skatteverket. Individen ska därför betraktas som en anställd, inte en egenföretagare, i detta sammanhang.",
  "seeAppendix": "Se bilaga 'Övrig information'.",
  "confirmAccurate": "Jag bekräftar att all information som lämnats för anställningsbeviset är korrekt och fullständig efter bästa vetskap. Jag förstår att felaktig eller ofullständig information kan påverka min rätt till arbetslöshetsersättning eller annan offentlig ersättning, och att jag är personligt ansvarig för den inlämnade informationen och eventuella konsekvenser till följd av felaktigheter.",
  
  // Footer
  "Cancel": "Avbryt",
  "Submitemployercertifcate": "Skapa",
  "Update": "Uppdatera",
  "Save Draft": "Spara utkast",
  "Update Draft": "Uppdatera utkast",
  "Saving...": "Sparar...",
  "employerCertificateCreatedSuccessfully": "Arbetsgivarintyget skapades framgångsrikt",
  "employerCertificateUpdatedSuccessfully": "Arbetsgivarintyget uppdaterades framgångsrikt",
  "employerCertificateDeletedSuccessfully": "Arbetsgivarintyget raderades framgångsrikt",
  "somethingWentWrong": "Något gick fel",
  "Draft saved successfully": "Utkastet sparades framgångsrikt",
  "Failed to save draft": "Det gick inte att spara utkastet",
  "Draft updated successfully": "Utkastet uppdaterades framgångsrikt",
  "Failed to update draft": "Det gick inte att uppdatera utkastet",

  // Draft Certificate
  "Draft Employer Certificate": "Utkast arbetsgivarintyg",
  "Are you sure you want to delete this Draft Employer Certificate?": "Är du säker på att du vill ta bort detta utkast till arbetsgivarintyg?",
  "Present": "Nuvarande",

  // Work Hours Empty State
  "No data found for selected period": "Ingen data hittades för vald period",
  "You can still fill the fields manually if needed.": "Du kan fortfarande fylla i fälten manuellt om det behövs.",
  "No Data": "Ingen data",
  "No data": "Ingen data",
};
